import "./FilterSearchBar.scss";
import Modal from "../Modal/Modal";
import FlowTextInput from "../FlowTextInput/FlowTextInput";
import { useRef, useState, useEffect } from "react";
import Responsible from "../../pages/Tasks/Modals/Responsible/Responsible";
import TaskStatus from "../../pages/Tasks/Modals/TaskStatus/TaskStatus";
import Priority from "../../pages/Tasks/Modals/TaskPriority/TaskPriority";
import UserAvatar from "../UserAvatar/UserAvatar";

function FilterSearchBar({
  onSearchChange,
  onResponsibleFilter,
  onStatusFilter,
  onPriorityFilter,
  onClearFilters,
  selectedResponsible,
  selectedStatus,
  selectedPriority,
  searchValue = "",
  statusConfig = [],
  priorityConfig = [],
}) {
  const modalRef = useRef();
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  // Sync internal state with external value
  useEffect(() => {
    if (searchValue !== searchText) {
      setSearchText(searchValue);
    }
  }, [searchValue, searchText]);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const handleSearchChange = (value) => {
    setSearchText(value);
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const openModal = (e, arrow, content) => {
    const triggerElement = e.currentTarget;

    if (modalRef.current) {
      modalRef.current.open({
        arrow,
        content,
        triggerElement,
      });
    }
  };

  const handleResponsibleSelect = (member) => {
    if (onResponsibleFilter) {
      onResponsibleFilter(member);
    }
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const handleStatusSelect = (status) => {
    if (onStatusFilter) {
      onStatusFilter(status);
    }
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const handlePrioritySelect = (priority) => {
    if (onPriorityFilter) {
      onPriorityFilter(priority);
    }
    if (modalRef.current) {
      modalRef.current.close();
    }
  };

  const handleClearFilters = () => {
    setSearchText("");
    if (onSearchChange) {
      onSearchChange("");
    }
    if (onClearFilters) {
      onClearFilters();
    }
  };

  return (
    <div className="filter-search-bar">
      <Modal ref={modalRef}></Modal>
      <div className="filter-search-wrapper">
        <div className="filter-buttons-container">
          <div
            className={`filter-button ${selectedResponsible ? "active" : ""}`}
            onClick={(e) =>
              openModal(
                e,
                "top-left",
                <Responsible
                  updateResponsible={handleResponsibleSelect}
                  selectedResponsible={selectedResponsible}
                />,
              )
            }
          >
            {selectedResponsible ? (
              <UserAvatar user={selectedResponsible} size="small" />
            ) : (
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "20px" }}
              >
                person
              </span>
            )}
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              arrow_drop_down
            </span>
          </div>
          {/* <div
            className="filter-button"
            onClick={(e) => openModal(e, "bottom", "Filter options here")}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              filter_list
            </span>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              arrow_drop_down
            </span>
          </div> */}
          <div
            className={`filter-button ${selectedStatus ? "active" : ""}`}
            onClick={(e) =>
              openModal(
                e,
                "top-left",
                <TaskStatus
                  updateStatus={handleStatusSelect}
                  selectedStatus={selectedStatus}
                  showClear={true}
                  statusConfig={statusConfig}
                />,
              )
            }
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              avg_pace
            </span>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              arrow_drop_down
            </span>
          </div>
          <div
            className={`filter-button ${selectedPriority !== null ? "active" : ""}`}
            onClick={(e) =>
              openModal(
                e,
                "top-left",
                <Priority
                  updatePriority={handlePrioritySelect}
                  selectedPriority={selectedPriority}
                  priorityConfig={priorityConfig}
                />,
              )
            }
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              priority_high
            </span>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              arrow_drop_down
            </span>
          </div>
          <div className="filter-button" onClick={handleClearFilters}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              close
            </span>
          </div>
        </div>
        <div className="input-search-container">
          <FlowTextInput
            ref={searchInputRef}
            placeholder="Search..."
            value={searchText}
            onChange={handleSearchChange}
            expandable={true}
            icon="search"
          />
        </div>
      </div>
    </div>
  );
}

export default FilterSearchBar;
